<template>
  <div v-if="localChat===null" class="text-center mt-10">
    <alert>Чат не выбран</alert>
  </div>
  <div v-else>
    <dialog-page-chat-toolbar
        :key="localChat.id"
        :cats="cats"
        :chat="localChat"
        :small="small"
        @close="$emit('close')"
    />
    <v-divider/>
    <v-progress-linear v-if="messagesLoading" background-color="transparent" class="position-absolute" indeterminate/>
    <v-sheet
        ref="messages"
        :max-height="heightCalc"
        :min-height="heightCalc"
        class="overflow-y-auto pt-2"
        @scroll.passive="collectVisibleMessagesForRead"
    >
      <div v-for="v in messages" :key="v.id">
        <dialog-page-message
            :data-id="v.id"
            :message="v"
            :cat="chat.cat"
            class="message"
        />
      </div>
    </v-sheet>
    <dialog-page-chat-message-sender
        ref="sender"
        :chat="localChat"
        :messageTemplates="messageTemplates"
        @heightUpdate="(v)=>heightSender=v"
        @scrollBottom="scrollBottom"
        @requestTemplateSelect="(item)=>$emit('requestTemplateSelect', item)"
    />
  </div>
</template>

<script>
import Alert from "../../../../componentsV2/base/Alert.vue";
import DialogPageChatToolbar from "./DialogPageChatToolbar.vue";
import axios from "axios";
import DialogPageMessage from "./DialogPageMessage.vue";
import DialogPageChatMessageSender from "./DialogPageChatMessageSender.vue";
import Stater from "../../../../plugins/stater";

export default {
  components: {DialogPageChatMessageSender, DialogPageMessage, DialogPageChatToolbar, Alert},
  props: ['height', 'cats', 'chat', 'messageTemplates', 'small'],
  data: () => ({
    localChat: null,
    subscribeListenerId: null,
    messages: [],
    messagesLoading: false,
    heightCalc: 0,
    heightSender: 0,

    messageReadTimer: null,
    messageReadIds: [],
    messageReadState: new Stater(),
  }),
  mounted() {
    this.localChat = this.chat;
    this.heightResize();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v) => this.subscribeListenerId = v, (m) => {
      if (m.type === 'dialogMessage' && this.localChat?.id === m.data.dialogChat?.id) {
        this.newDialogMessage(m.data);
        return;
      }
      if (m.type === 'dialogChat' && this.localChat?.id === m.data.id) {
        this.localChat = m.data;
        if (m.data.dialogMesLast)
          this.newDialogMessage(m.data.dialogMesLast);
      }
      if (m.type === 'dialogMessageLog') this.newDialogMessageLog(m.data);
      if (m.type === 'dialogMessageReaction') this.newDialogMessageReaction(m.data);
    });
    this.initMessageAutoRead();
  },
  beforeDestroy() {
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    clearInterval(this.messageReadTimer);
  },
  watch: {
    chat() {
      this.heightSender = 0;
      this.localChat = this.chat
      this.heightResize();
    },
    localChat(newChat, oldChat) {
      if (newChat?.id !== oldChat?.id)
        this.loadMessages();
    },
    height() {
      this.heightResize()
    },
    heightSender() {
      this.heightResize()
    },
  },
  methods: {
    heightResize() {
      this.$tools.debounce(() => {
        this.$nextTick(() => {
          this.heightCalc = this.height - 48 - 1 - this.heightSender;
          if (this.chat?.cat !== 'internal' && !this.small) {
            this.heightCalc -= 48;
          }
        })
      }, 100, 'chatHeightResize');
    },
    scrollBottom() {
      let scroll = () => {
        if(this.$refs.messages)
          this.$refs.messages.$el.scrollTop = this.messages.length * 1000;
      };
      this.$nextTick(scroll);
      setTimeout(scroll, 100);
      setTimeout(scroll, 500);
    },
    loadMessages() {
      if (this.localChat === null) {
        this.messages = [];
        return;
      }

      this.messages = [];
      this.messagesLoading = true;
      axios.get('/napi/dialog/chat/' + this.localChat.id + '/message/')
          .then(r => {
            this.messages = r.data.reverse();
            this.messagesLoading = false;
            this.scrollBottom();
          });
    },
    isCurrentUserInChat() {
      if (this.localChat === null || this.$store.state.user === null)
        return false;
      return (this.localChat.dialogUsers || []).some(v => v.user?.id === this.$store.state.user?.id);
    },
    isMessageNeedRead(message) {
      if (message === null || this.$store.state.user === null)
        return false;
      if (message.type === 'event')
        return false;
      if (message.dialogUser?.user?.id === this.$store.state.user?.id && message.dialogUser.provider === 'internal')
        return false;
      return (message.dialogMessageLogs || []).filter(
          v => v.type === 'read' && v.dialogUser?.user?.id === this.$store.state.user?.id
      ).length === 0;
    },
    isMessageVisibleInMessagesContainer(messageElement) {
      let containerElement = this.$refs.messages?.$el;
      if (containerElement === undefined)
        return false;

      let containerRect = containerElement.getBoundingClientRect();
      let messageRect = messageElement.getBoundingClientRect();
      let visibleTop = Math.max(messageRect.top, containerRect.top);
      let visibleBottom = Math.min(messageRect.bottom, containerRect.bottom);
      let visibleHeight = visibleBottom - visibleTop;

      if (visibleHeight <= 0 || messageRect.height <= 0)
        return false;
      return visibleHeight / Math.min(messageRect.height, containerRect.height) >= 0.5;
    },
    collectVisibleMessagesForRead() {
      if (!this.isCurrentUserInChat() || (this.localChat?.cat !== 'internal' && this.localChat?.cat !== 'process') || this.$refs.messages?.$el === undefined)
        return;

      this.$refs.messages.$el
          .querySelectorAll('.message:not([data-read-send])')
          .forEach(v => {
            if (!this.isMessageVisibleInMessagesContainer(v))
              return;

            let id = parseInt(v.getAttribute('data-id'), 10);
            if (isNaN(id))
              return;

            let message = this.messages.find(v1 => String(v1.id) === String(id)) || null;
            if (!this.isMessageNeedRead(message))
              return;

            v.setAttribute('data-read-send', 'true')
            if (!this.messageReadIds.includes(id))
              this.messageReadIds.push(id);
          })
    },
    sendMessageReadBatch() {
      if (!this.isCurrentUserInChat())
        return;
      if (this.messageReadIds.length === 0)
        return;
      if (this.messageReadState.loading)
        return;

      this.messageReadState.stateLoading()
      let messageReadIds = this.$tools.copy(this.messageReadIds);
      axios.put('/napi/dialog/message/readed/', messageReadIds)
          .then(() => {
            this.messageReadIds = this.messageReadIds.filter(v => !messageReadIds.includes(v))
            this.messageReadState.stateSuccess()
          })
          .catch(e => {
            this.messageReadState.stateError(e)
          });
    },
    initMessageAutoRead() {
      this.messageReadTimer = setInterval(() => {
        this.collectVisibleMessagesForRead();
        this.sendMessageReadBatch();
      }, 2000);
    },
    newDialogMessage(d) {
      let index = this.messages.findIndex(v => v.id === d.id);
      if (index === -1) {
        this.messages.push({
          ...d,
          dialogMessageLogs: d.dialogMessageLogs || [],
          dialogMessageAttachs: d.dialogMessageAttachs || [],
          buttons: d.buttons || [],
          reply: d.reply || null,
        });
        this.scrollBottom();
        return;
      }
      this.$set(this.messages, index, {...this.messages[index], ...d});
    },
    newDialogMessageLog(d) {
      let messageIndex = this.messages.findIndex(v => v.id === d.dialogMessage.id);
      if (messageIndex === -1)
        return;

      let message = this.messages[messageIndex];
      this.$set(this.messages, messageIndex, {
        ...message,
        dialogMessageLogs: [...(message.dialogMessageLogs || []), d]
      });
    },
    newDialogMessageReaction(d) {
      let messageIndex = this.messages.findIndex(v => v.id === d.id);
      if (messageIndex === -1)
        return;

      this.$set(this.messages[messageIndex], 'reaction', d.data);
    },
    messageTemplateSelect(v) {
      this.$refs.sender?.messageTemplateSelect(v);
    }
  }
}
</script>